import type { FC } from 'react';
import type { TCallPhase } from './types';

const HALF = 'M5 .9 A4.1 4.1 0 0 0 5 9.1 Z';

interface IProps {
  phase: TCallPhase;
  isHeld?: boolean;
  className?: string;
}

/**
 * 10px state glyph. Four silhouettes — solid disc, half disc, hollow ring,
 * dashed ring — the same shape language as the licensed-capacity readout, so
 * the two instruments teach each other. Colour is reinforcement, never the
 * signal, and it comes from the parent via currentColor so light and dark are
 * one stylesheet rule rather than a branch in here.
 */
const StateGlyph: FC<IProps> = ({ phase, isHeld, className }) => {
  if (phase === 'connected' && !isHeld) {
    return (
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        className={className}
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="5" cy="5" r="4.5" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="5"
        cy="5"
        r="4.1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeDasharray={
          // Dashed means "nothing live on the wire" — true before a dial starts
          // and after the contact ends; the label tells the two apart.
          phase === 'ended' || phase === 'idle' ? '2.2 1.9' : undefined
        }
      />
      {isHeld && <path d={HALF} fill="currentColor" />}
    </svg>
  );
};

export default StateGlyph;
